import React from 'react'
import GalleryList from '../components/gallery/GalleryList'

const Gallery = () => {
  return (
    // <div className="pt-16 max-w-7xl mx-auto px-4"> 
    //   <GalleryList />
    // </div>
    <div className="pt-16 max-w-7xl mx-auto px-4"> 
    <GalleryList />
  </div>
  )
}

export default Gallery



